import { ITableAdapter } from '../../../../../../generic/universal-table/types/adapter.types'
import { CarApiRow, CarCreatePayload, CarUiRow, CarUpdatePayload } from '../types/carTable.types'

export const carTableAdapter: ITableAdapter<
  CarApiRow,
  CarUiRow,
  CarCreatePayload,
  CarUpdatePayload
> = {
  fromApi: (row: CarApiRow): CarUiRow => ({
    Active: row.Active ?? false,
    CarID: row.CarID,
    CarNum: row.CarNum ?? 0,
    DriverID: row.DriverID ?? 0,
    DriverName: row.DriverName?.trim() ?? '',
    DriverWorkerId: row.DriverWorkerId ?? 0,
    EmptyTrackWght: row.EmptyTrackWght ?? 0,
    FreightCompanyID: row.FreightCompanyID ?? 0,
    IsChargeHovala: row.IsChargeHovala ?? false,
    Max_Weight: row.Max_Weight ?? 0,
    Pallets: row.Pallets ?? 0,
    Phone: row.Phone?.trim() ?? '',
  }),

  toCreatePayload: ({ CarID: _, ...rest }: CarUiRow): CarCreatePayload => rest,

  toUpdatePayload: ({ CarID: _, ...rest }: CarUiRow): CarUpdatePayload => rest,

  getRowId: (row: CarUiRow): number => row.CarID,
}
